/**
 * 【KYMW1400】コマ情報更新VO
 *
 * @export UpdateKomaModel
 * @class UpdateKomaModel
 */
export class UpdateKomaModel {
  /**
   * コマID
   */
  public komaID = Number(0);

  /**
   * セクションID
   */
  public sectionID = Number(0);

  /**
   * 始点X
   */
  public positionX = Number(0);

  /**
   * 始点Y
   */
  public positionY = Number(0);

  /**
   * 幅
   */
  public sizeW = Number(0);

  /**
   * 高さ
   */
  public sizeH = Number(0);

  /**
   * ページ番号
   */
  public pageNum = Number(0);

  /**
   * 掲載料請求枠数
   */
  public publishAmountLimitNum = Number(0);
}
